import type { AssistantStep } from './types';

/** Lo que se sugiere en el estado vacío depende de dónde está el usuario. */
export const SUGGESTIONS_BY_STEP: Record<AssistantStep, string[]> = {
  inicio: [
    'Factúrale a público en general',
    '¿Qué necesito para facturarle a una empresa?',
    '¿Me pagaron de contado o en parcialidades?',
  ],
  conceptos: [
    'Agrega consultoría por $8,000',
    '¿Qué clave del SAT uso para diseño gráfico?',
    '¿Qué significa cobrar el monto que quiero recibir?',
  ],
  pago: [
    'Me pagaron de contado por transferencia',
    'Me van a pagar en parcialidades',
    'Me pagaron en dólares',
  ],
  revisar: [
    '¿Ya está lista para timbrar?',
    '¿Por qué lleva este uso de CFDI?',
    'Cámbiala a pago en efectivo',
  ],
};
